const PRINT_FRAME_ID = 'voucher-print-frame'

const PRINT_STYLES = `
  @page {
    size: A4 portrait;
    margin: 10mm;
  }

  html,
  body {
    margin: 0;
    padding: 0;
    color: #000;
    background: #fff;
    font-family: sans-serif;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  #voucherPrint {
    width: 900px;
    margin: 0;
    padding: 0;
  }

  #voucherPrint > table {
    width: 900px !important;
    max-width: 900px;
    break-inside: avoid;
    page-break-inside: avoid;
  }

  table {
    border-collapse: collapse;
  }
`

export default function printElement (element) {
  return new Promise((resolve, reject) => {
    if (!element) {
      reject(new Error('Konten voucher tidak ditemukan.'))
      return
    }

    const previousFrame = document.getElementById(PRINT_FRAME_ID)
    if (previousFrame && previousFrame.parentNode) {
      previousFrame.parentNode.removeChild(previousFrame)
    }

    const frame = document.createElement('iframe')
    frame.id = PRINT_FRAME_ID
    frame.setAttribute('title', 'Print voucher')
    frame.setAttribute('aria-hidden', 'true')
    Object.assign(frame.style, {
      position: 'fixed',
      right: '100%',
      bottom: '100%',
      width: '1px',
      height: '1px',
      border: '0'
    })
    document.body.appendChild(frame)

    const printWindow = frame.contentWindow
    const printDocument = frame.contentDocument

    if (!printWindow || !printDocument) {
      frame.parentNode.removeChild(frame)
      reject(new Error('Browser tidak dapat menyiapkan dokumen print.'))
      return
    }

    printDocument.open()
    printDocument.write('<!doctype html><html><head><meta charset="utf-8"><title>Voucher</title></head><body></body></html>')
    printDocument.close()

    const style = printDocument.createElement('style')
    style.textContent = PRINT_STYLES
    printDocument.head.appendChild(style)
    printDocument.body.appendChild(element.cloneNode(true))

    let completed = false
    let cleanupTimer = null
    const complete = () => {
      if (completed) return
      completed = true
      if (cleanupTimer) window.clearTimeout(cleanupTimer)
      window.setTimeout(() => {
        if (frame.parentNode) frame.parentNode.removeChild(frame)
      }, 0)
      resolve()
    }

    printWindow.addEventListener('afterprint', complete)

    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        try {
          printWindow.focus()
          printWindow.print()
          if (!completed) cleanupTimer = window.setTimeout(complete, 60000)
        } catch (error) {
          if (frame.parentNode) frame.parentNode.removeChild(frame)
          reject(error)
        }
      })
    })
  })
}
